import { createContext, useContext } from "react";

import type { HereAndNowTab } from "@lib/logic";

import type { HereAndNowData } from "../data/useHereAndNowData";

export type HaNContextValue = HereAndNowData & {
  tab: HereAndNowTab;
};

export const HaNContext = createContext<HaNContextValue | null>(null);

export const useHaN = () => {
  const context = useContext(HaNContext);

  if (!context) throw new Error("useHaN must be used within HaN.Page");

  return context;
};
